import { useTranslation } from "react-i18next"
import Select from "../../components/form-controls/Select";
import TextArea from "../../components/form-controls/TextArea";
import Input from "../../components/form-controls/Input";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
function FormNotificationPartial({ data, onClose ,isLastNotification}) {
  const { t } = useTranslation();
  const [timeOptions, setTimeOptions] = useState([]);
  const [isCheckedClose, setIsCheckedClose] = useState(false);
  const [isCheckedWebHook, setIsCheckedWebHook] = useState(false);
  const [customHeadersDev, setCustomHeadersDev] = useState([]);
  const [customHeadersProd, setCustomHeadersProd] = useState([]);

  const defaultValues = {
    after_minutes: 5,
    text: {
      es: ''
    },
    close: {
      category: ''
    },
    webhook: {
      url_dev: '',
      headers_dev: [],
      url_prod: '',
      headers_prod: []
    }
  }
  const { control, register, watch, getValues, setValue, reset, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
    mode: 'onChange',
    defaultValues
  });

  const submit = async (data) => {
    data.after_minutes = parseInt(data.after_minutes);
    const headersDevArray = customHeadersDev.map(header => ({
      [header.key]: header.value
    }));

    const headersProdArray = customHeadersProd.map(header => ({
      [header.key]: header.value
    }));
    if (isCheckedWebHook) {
      data.webhook.headers_dev = headersDevArray;
      data.webhook.headers_prod = headersProdArray;
    }
    
    !isCheckedClose && delete data.close;
    !isCheckedWebHook && delete data.webhook;
    setCustomHeadersDev([]);
    setCustomHeadersProd([]);
    onClose(data);
  }


  const handleAddHeaderDev = () => {
    setCustomHeadersDev([...customHeadersDev, { key: '', value: '' }]);
  };

  const handleRemoveHeaderDev = (index) => {
    const headersCopy = [...customHeadersDev];
    headersCopy.splice(index, 1);
    setCustomHeadersDev(headersCopy);
  };

  const handleHeaderChangeDev = (index, field, value) => {
    const headersCopy = [...customHeadersDev];
    headersCopy[index][field] = value;
    setCustomHeadersDev(headersCopy);
  };

  const handleAddHeaderProd = () => {
    setCustomHeadersProd([...customHeadersProd, { key: '', value: '' }]);
  };

  const handleRemoveHeaderProd = (index) => {
    const headersCopy = [...customHeadersProd];
    headersCopy.splice(index, 1);
    setCustomHeadersProd(headersCopy);
  };

  const handleHeaderChangeProd = (index, field, value) => {
    const headersCopy = [...customHeadersProd];
    headersCopy[index][field] = value;
    setCustomHeadersProd(headersCopy);
  };

  const handleCheckboxChangeClose = (event) => {
    setIsCheckedClose(event.target.checked);
  };

  const handleCheckboxChangeWebHook = (event) => {
    setIsCheckedWebHook(event.target.checked);
  };

  useEffect(() => {
    const options = [];
    for (let i = 5; i <= 60; i += 5) {
      options.push({ value: i, text: ` ${i} ${t('date-time.minutes')}` });
    }
    setTimeOptions(options);
  }, [])

  useEffect(() => {
    if (data) {
      reset(Object.assign(defaultValues, data))
      data.close && setIsCheckedClose(true);
      if (data.webhook) {
        setIsCheckedWebHook(true);
        const headersDev = data?.webhook.headers_dev.map(header => {
          const [key, value] = Object.entries(header)[0];
          return { key, value };
        });
        const headersProd = data?.webhook.headers_prod.map(header => {
          const [key, value] = Object.entries(header)[0];
          return { key, value };
        });
        setCustomHeadersDev(headersDev);
        setCustomHeadersProd(headersProd);
      } else {
        setIsCheckedWebHook(false);
        setCustomHeadersDev([]);
        setCustomHeadersProd([]);
      }
    } else {
      reset(defaultValues);
    }
  }, [data])

  return (
    <>
      <div className='push-view view-node show'>
        <div className="card-header  d-flex align-items-center">
          <button type="button" className="btn btn-ghost-light btn-icon ml-negative-1" style={{ height: 'auto' }} onClick={() => onClose()}>
            <i className="bi-chevron-left text-dark"></i>
          </button>
          <h3 className="card-header-title">{t('platform.chatbot.interactive-node.notification-title')}</h3>
        </div>
        <div className='card-body'>
          <div>
            <div className="my-3">
              <Select
                label={t("platform.chatbot.interactive-node.time-no-response")}
                data={timeOptions}
                errors={errors.after_minutes}
                {...register('after_minutes', { required: true })}
              />
            </div>
            <div className="mb-3">
              <TextArea
                label={t("platform.chatbot.interactive-node.message")}
                errors={errors.text?.['es']}
                value={watch('text.es').length}
                counter={1024}
                {...register('text.es', { required: true, maxLength: { value: 1024, message: '1024' } })} />
            </div>
            <div className="form-check form-switch ps-0 mb-3 d-flex">
              <label className="form-check-label" htmlFor="formSwitch1">
                <h5>{t("platform.chatbot.interactive-node.webhook")}</h5>
              </label>
              <input type="checkbox" className="form-check-input ms-auto" id="formSwitch1" checked={isCheckedWebHook} onChange={handleCheckboxChangeWebHook} />
            </div>
            {
              isCheckedWebHook &&
              <>
                <div className="mb-3">
                  <div className="mt-3">
                    <Input
                      label={t("platform.chatbot.http-node.url-development")}
                      errors={errors.webhook?.url_dev}
                      {...register('webhook.url_dev', { required: true })}
                    />
                  </div>
                  <label className="form-check-label mt-3">
                    <p className="form-label me-2">{t("platform.chatbot.interactive-node.header-dev")}</p>
                  </label>
                  <span className="text-muted">{t("platform.chatbot.interactive-node.optional")}</span>
                  {customHeadersDev.map((header, index) => (
                    <div key={index} className="mb-2">
                      <div className="d-flex mb-2">
                        <div className="flex-grow-1 me-2">
                          <label>{t("Key")}</label>
                          <Input
                            value={header.key}
                            onChange={(e) => handleHeaderChangeDev(index, "key", e.target.value)}
                          />
                        </div>
                        <div className="flex-grow-1 me-2">
                          <label>{t("Value")}</label>
                          <Input
                            value={header.value}
                            onChange={(e) => handleHeaderChangeDev(index, "value", e.target.value)}
                          />
                        </div>
                        <div className="d-flex align-items-end">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemoveHeaderDev(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button type="button" className="btn btn-secondary btn-sm mt-2 d-flex align-items-center justify-content-center" onClick={handleAddHeaderDev}>
                    <i className="bi bi-plus-lg"></i>
                  </button>
                </div>

                <div className="mb-3 border-top border-bottom">
                  <div className="mt-3">
                    <Input
                      label={t("platform.chatbot.http-node.url-production")}
                      errors={errors.webhook?.url_prod}
                      {...register('webhook.url_prod', { required: true })}
                    />
                  </div>
                  <label className="form-check-label mt-3">
                    <p className="form-label me-2">{t("platform.chatbot.interactive-node.header-prod")} </p>
                  </label>
                  <span className="text-muted">{t("platform.chatbot.interactive-node.optional")}</span>
                  {customHeadersProd.map((header, index) => (
                    <div key={index} className="mb-2">
                      <div className="d-flex mb-2">
                        <div className="flex-grow-1 me-2">
                          <label>{t("Key")}</label>
                          <Input
                            value={header.key}

                            onChange={(e) => handleHeaderChangeProd(index, "key", e.target.value)}
                            required
                          />
                        </div>
                        <div className="flex-grow-1 me-2">
                          <label>{t("Value")}</label>
                          <Input
                            value={header.value}

                            onChange={(e) => handleHeaderChangeProd(index, "value", e.target.value)}
                            required
                          />
                        </div>
                        <div className="d-flex align-items-end">
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => handleRemoveHeaderProd(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  <button type="button" className="btn btn-secondary btn-sm mt-2 d-flex align-items-center justify-content-center mb-4" onClick={handleAddHeaderProd}>
                    <i className="bi bi-plus-lg"></i>
                  </button>

                </div>
              </>
            }
            {
              isLastNotification &&
              <div className="my-4">
                <div className="form-check form-switch ps-0 mb-3 d-flex">
                  <label className="form-check-label" htmlFor="formSwitch1">
                    <h5>{t("platform.chatbot.interactive-node.close-ticket")}</h5>
                  </label>
                  <input type="checkbox" className="form-check-input ms-auto" id="formSwitch1" checked={isCheckedClose} onChange={handleCheckboxChangeClose} />
                </div>
                {
                  isCheckedClose &&
                  <div className="mb-3">
                    <Input label={t("platform.chatbot.interactive-node.close-category")} errors={errors.close?.category} {...register('close.category', { required: true })} />
                  </div>
                }
              </div>}
            <div className="d-grid gap-2 mt-5  mb-3 ">
              <button type="button" className="btn btn-primary" onClick={handleSubmit(submit)} disabled={!isValid || !customHeadersDev.every(header => header.key && header.value) || !customHeadersProd.every(header => header.key && header.value)}>{t('btn-save')}</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FormNotificationPartial